// extracted by mini-css-extract-plugin
export default {"mainCard":"CardInfo_mainCard__5cI1l"};